import $ from 'jquery';
import {findObjectById, getLocacion} from '../../util';



export class ContableCuentaApi {
    
    static activar(id, token) {  
       return $.ajax({
 			headers: {"Authorization": "Bearer " + token.idToken}, 
        	url: getLocacion()+ "/api/contablecuenta/activar/"+id,
			type: "PUT",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
     static borrar(id, token) {  
       return $.ajax({
 			headers: {"Authorization": "Bearer " + token.idToken}, 
        	url: getLocacion()+ "/api/contablecuenta/"+id,
			type: "DELETE",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
    static getContableCuentaList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token ) {
        
         return $.ajax({
 			headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/contablecuenta?page="+pagina+"&size="+regitrosPorPagina+"&filtro="+filtro+"&activos="+showActivos,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)
					window.location = getLocacion()+'/login';
				}
			}
		});
      
	}
    
    
    static getContableCuenta(id, token ) {  
         return $.ajax({
 			headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/contablecuenta/"+id,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)
					window.location = getLocacion()+'/login';
				}
			}
		});
        
	}
    
    
    static save(contablecuenta, token ) {          
      let contablecuentaEnvio = Object.assign({}, contablecuenta);
		let comando="POST";
		if (contablecuentaEnvio.id > 0) {
			comando="PUT";			
		} 
		contablecuentaEnvio=JSON.stringify(contablecuentaEnvio);
		return $.ajax({
 			headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/contablecuenta/",
			type: comando,
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			data: contablecuentaEnvio,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)
					window.location = getLocacion()+'/login';
				}
			}
		});
	}   
    
    static getContableCuentaCombo(token ) {

		return $.ajax({
 			headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/contablecuenta/combo/",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    
     

    
}